export default "__VITE_ASSET__CgM5JY6i__"